import React from "react";

type ModalProviderProps = {
  children: React.ReactNode;
};

export function ModalProvider({ children }: ModalProviderProps) {
  return <>{children}</>;
}

export default ModalProvider;
